// extracted by mini-css-extract-plugin
module.exports = {"createGoalPage":"createGoalPage-3EZQi"};